module.exports = "/_next/static/images/icon1-e5df2fc3651f24655f173c996108e005.png";